export function copyToClipboard(textElement, buttonIconElement) {
  textElement.select();
  textElement.setSelectionRange(0, 99999); /*For mobile devices*/
  document.execCommand("copy");
  buttonIconElement.classList.remove("fa-copy");
  buttonIconElement.classList.add("fa-check-circle", "text-primary");
}
